
import React, { Component } from 'react';
import { reduxForm } from 'redux-form'
import classes from '../Modals/./Modals.css';
import moment from 'moment';
import { Button } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';

const QIF = props => {

    const handleSubmit = () => {
        return props.importQIF();
    }
    
    let buttonText = 'Confirm Import';
    if (props.submitting) buttonText = <CircularProgress size={24} />;
    if (props.submitSucceeded) buttonText = <CheckIcon size={24} />;
    return (
        <form onSubmit={props.handleSubmit(handleSubmit)}>
            <div className={classes.container}>
                <h3>Import Transactions</h3>
                <div className={classes.infoBox}>
                    <p><strong>{props.data.records}</strong> transactions will be imported</p>
                    <p>Account: <strong>{props.account.label}</strong></p>
                    <p>Between: <strong>{moment(props.data.startDate).format('DD MMM YYYY')}</strong> and <strong>{moment(props.data.endDate).format('DD MMM YYYY')}</strong></p>
                    {(props.data.records > 2000) && <p className={classes.warningMessage}>This could take up to: {Math.ceil(props.data.records / 2000)} minutes to import</p>}
                </div>
                <label htmlFor="contained-button-file">
                    <Button variant="contained" color="primary" style={{ minWidth: 164 }} type="submit" disabled={props.submitting || props.submitSucceeded}>{buttonText}</Button>&nbsp;&nbsp;&nbsp;
                    <Button variant="contained" onClick={props.onClose}>Cancel</Button>
                </label>
                {(props.submitting) && <div className={classes.message}>Importing transactions please wait...</div>}
            </div>
        </form>
    )
}

export default reduxForm({
    form: 'qifForm' // a unique identifier for this form
  })(QIF)


// WEBPACK FOOTER //
// ./src/components/UploadTransactions/QIF.js